import React from 'react';
import { motion } from 'framer-motion';
import SectionHeader from './ui/SectionHeader';

const useCases = [
  {
    title: 'The Daily Commuter',
    size: '20oz Cup',
    desc: 'Fits standard car cup holders and fits under most barista machines.',
    img: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=600&auto=format&fit=crop'
  },
  {
    title: 'The Day Hiker',
    size: '32oz Flask',
    desc: 'Ample hydration for 4-6 hour trails with impact-resistant base.',
    img: 'https://images.unsplash.com/photo-1551632811-561732d1e306?q=80&w=600&auto=format&fit=crop'
  },
  {
    title: 'The Office Anchor',
    size: '40oz Tumbler',
    desc: 'Maximum capacity to keep you hydrated through back-to-back meetings.',
    img: 'https://images.unsplash.com/photo-1497215728101-856f4ea42174?q=80&w=600&auto=format&fit=crop'
  }
];

export default function BuyingGuide() {
  return (
    <section className="py-32 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader title="Find Your Perfect Fit" subtitle="Buying Guide" />
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {useCases.map((item, idx) => (
            <motion.div 
              key={idx}
              whileHover={{ y: -10 }}
              className="bg-white rounded-3xl overflow-hidden shadow-sm border border-stone-200 flex flex-col"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img src={item.img} alt={item.title} className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700" />
              </div>
              <div className="p-8">
                <h3 className="text-xl font-bold text-stone-900 mb-1">{item.title}</h3>
                <span className="text-teal-700 font-medium text-sm block mb-4">{item.size}</span>
                <p className="text-stone-500 text-sm leading-relaxed mb-6">{item.desc}</p>
                <button className="text-stone-900 font-bold text-xs uppercase tracking-widest border-b border-stone-900 pb-1 hover:text-teal-700 hover:border-teal-700 transition-colors">
                  Shop {item.size}
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}